import React from "react";
import Swal from "sweetalert2";
import { useHistory } from 'react-router-dom';
import { useForm, Controller } from "react-hook-form";

// Material-UI
import { Button, Container, Grid, makeStyles } from "@material-ui/core";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
// Components
import NavbarUser from "../components/NavbarUser";
import Background from "../components/BackgroundPattern";
import TitlePage from "../components/TitlePageUser";
import TextPilih from "../components/TextPilih";
import Footer from "../components/Footer";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh"
  },
  bgWhite: {
    backgroundColor: "white"
  }
}))

const PilihTest = ( {classes}) => {
  const { handleSubmit, control } = useForm();
  const history = useHistory();
  const onSubmit = (data) => {
    console.log(data);
    if (data.pilihSoal !== "Pretest") {
      return Swal.fire({
        icon: "error",
        title: "Tes Belum Dimulai",
        text: "Silahkan Pilih Tes yang sedang dilaksanakan",
      });
    } else {
      return history.push('/user/soal/pretest')
    }
  };

  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs={6} sm={6} md={5}>
            <FormControl className={classes.bgWhite} variant="outlined" margin="normal" required fullWidth>
              <InputLabel id="pilihSoalLabel">{"Pilih Tes"}</InputLabel>
              <Controller
                as={
                  <Select
                    labelId="pilihSoalLabel"
                    id="pilihSoal"
                    label="Pilih Tes"
                  >
                    <MenuItem value="">
                      <em>Pilih Jenis Tes </em>
                    </MenuItem>
                    <MenuItem value="Pretest">{"Pretest"}</MenuItem>
                    <MenuItem value="WeeklyTest-1">{"WeeklyTest-1"}</MenuItem>
                    <MenuItem value="WeeklyTest-2">{"WeeklyTest-2"}</MenuItem>
                    <MenuItem value="WeeklyTest-3">{"WeeklyTest-3"}</MenuItem>
                    <MenuItem value="WeeklyTest-4">{"WeeklyTest-4"}</MenuItem>
                    <MenuItem value="Posttest">{"Posttest"}</MenuItem>
                  </Select>
                }
                name="pilihSoal"
                control={control}
                defaultValue=""
                required
              />
            </FormControl>
          </Grid>
          <Grid item xs={5} sm={4} md={3}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              type="submit"
              fullWidth
            >
              {"Pilih"}
            </Button>
          </Grid>
          <Grid item xs={1} sm={2} md={4}></Grid>
        </Grid>
      </form>
    </Container>
  );
};

const UserSoal = () => {
  const classes = useStyles();
  return (
    <section id="tes-latihan" className={classes.container}>
      <Background/>
      <NavbarUser />
      <Container style={{flex: "1"}}>
        <TitlePage text="Tes Pelatihan" />
        <TextPilih text="Pilih Tes Pelatihan yang akan dikerjakan"/>
        <PilihTest classes={classes} />
      </Container>
      <Footer />
    </section>
  );
};

export default UserSoal;
